import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import * as Yup from "yup";

import Button from "../../components/Button";
import Input from "../../components/Input";
import { showError, showToast } from "../../helpers/showToast";
import { usePostResetPasswordMutation } from "../../service/auth";
import { CommonBody } from "../../types/General";
import { generateEncryptedKeyBody } from "../../utils/crypto";

import AuthLayout from "./AuthLayout";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [resetPassword] = usePostResetPasswordMutation();

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .label("new Password")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/,
          "Password must be at least 8 characters long and include 1 uppercase, 1 lowercase, and 1 special character."
        )
        .required("New password is required."),

      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "Passwords must match.")
        .required("Confirm password is required."),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      const body = {
        newPassword: formik.values.confirmPassword,
      };

      try {
        const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await resetPassword(encryptedBody).unwrap();
        if (response?.statusCode === 200) {
          navigate("/");
          showToast("Password changed successfully");
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
      }
      formik.setSubmitting(false);
    },
  });

  return (
    <AuthLayout>
      <div className="authBox">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <figure>
            <img
              src="/static/images/logo.png"
              alt=""
              onClick={() => navigate("/dashboard")}
            />
          </figure>
        </div>
        <h2>New Password</h2>
        <p>Choose strong password for your account</p>
        <form onSubmit={formik.handleSubmit}>
          <Input
            placeholder="New Password"
            password
            id="newPassword"
            name="newPassword"
            isLoginField
            value={formik.values.newPassword}
            onChange={(val) => {
              if (val.target.value === " " || val.target.value === ".") {
              } else {
                formik.handleChange(val);
              }
            }}
            eyeIconColor="white"
            onBlur={formik.handleBlur}
            helperText={formik.touched.newPassword && formik.errors.newPassword}
          />
          <Input
            placeholder="Confirm Password"
            password
            id="confirmPassword"
            name="confirmPassword"
            isLoginField
            value={formik.values.confirmPassword}
            onChange={(val) => {
              if (val.target.value === " " || val.target.value === ".") {
              } else {
                formik.handleChange(val);
              }
            }}
            eyeIconColor="white"
            onBlur={formik.handleBlur}
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
            }
          />

          <div className="form_control d_flex" />
          <Button value="Update Password" type="submit" />
        </form>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
